import SDIcon from '../SDIcon'

const IconLineGrey = (props) => (
  <SDIcon viewBox='0 0 54 4' {...props}>
    <rect width='54' height='4' rx='2' fill='#A8BACD' />
  </SDIcon>
)

export default IconLineGrey
